import { createContext, useState } from "react"

// eslint-disable-next-line react-refresh/only-export-components
export const ItemsContext = createContext<{
  showFilters: boolean
  setShowFilters: (value: boolean) => void
}>({
  showFilters: false,
  setShowFilters: () => {},
})

export default function ItemsProvider({ children }: { children: React.ReactNode }) {
  const [showFilters, setShowFilters] = useState(false)

  return (
    <ItemsContext.Provider
      value={{
        showFilters,
        setShowFilters,
      }}
    >
      {children}
    </ItemsContext.Provider>
  )
}
